<template>
    <div class="is-flex is-justify-content-space-between is-align-items-center">
        <div class="is-flex is-justify-content-space-between">
            <div class="mr-6">
                <p class="is-size-7 is">
                    <span class="has-text-weight-bold">
                        {{ totalItems }}
                    </span>
                    <span>
                        {{ dataDescription }}
                    </span>
                </p>
            </div>
        </div>
        <div class="downloadBar_buttons">
            <ButtonOptions
                class="is-size-6 is-relative m-0"
                :list="availableDocuments"
                :email-sended="showSuccesfullMsg"
                @on-button-click="onSendEmail"
                v-if="downloadDoc"
                text=".xlsx"
                icon="arrow_downward"
            />
            <ButtonOptions
                class="is-size-6 is-relative m-0"
                :list="availableDocuments"
                :email-sended="showSuccesfullMsg"
                @on-button-click="onSendEmail"
                v-if="sendEmail"
                :text="btnSendEmailDesc"
            />
        </div>
    </div>
</template>

<script>
import ButtonOptions from "./ButtonOptions";
export default {
    name: "DownloadBar",
    components: {
        ButtonOptions,
    },
    props: {
        sendEmail: {
            type: Boolean,
            default: true,
        },
        downloadDoc: {
            type: Boolean,
            default: false,
        },
        totalItems: {
            type: Number,
            default: 0,
        },
        availableDocuments: {
            type: Array,
            default: () => [],
        },
        showSuccesfullMsg: {
            type: Boolean,
            default: null,
        },
        dataDescription: {
            type: String,
            default: "",
        },
        btnSendEmailDesc: {
            type: String,
            default: "Enviar data al correo",
        },
    },
    methods: {
        onSendEmail(data) {
            this.$emit("on-send-email", data);
        },
    },
    computed: {
        downloadStyle() {
            if (this.showSuccesfullMsg) return `pointer-events: none;`;
            else return "";
        },
    },
};
</script>
